import { useState } from "react";
import { assetUrl } from "@/lib/api";
import { cn } from "@/lib/utils";

const PALETTES = [
  ["#101625", "#222D42", "#B6FF5C"], ["#1A2140", "#7388FF", "#F6F8FC"], ["#222D42", "#101625", "#7388FF"], ["#141C33", "#3A4A7A", "#B6FF5C"],
];

export function BrandLogo({ brand, className = "h-14 w-14", textClass = "text-base" }) {
  const [failed, setFailed] = useState(false);
  const name = brand?.name || "?";
  const url = assetUrl(brand?.logo_url);
  if (url && !failed) {
    return (
      <div className={cn("flex items-center justify-center overflow-hidden rounded-2xl border border-ph-line bg-white p-2", className)}>
        <img src={url} alt={`${name} logo`} className="h-full w-full object-contain" onError={() => setFailed(true)} />
      </div>
    );
  }
  const initials = name.replace(/[^A-Z0-9&]/gi, " ").trim().split(/\s+/).map((w) => w[0]).join("").slice(0, 3) || name.slice(0, 2);
  const [a, b, ink] = PALETTES[name.charCodeAt(0) % PALETTES.length];
  return (
    <div
      className={cn("relative flex items-center justify-center overflow-hidden rounded-2xl border border-white/10 font-display font-extrabold tracking-tight", className, textClass)}
      style={{ background: `linear-gradient(140deg, ${a} 0%, ${b} 130%)`, color: ink }}
      aria-label={`${name} monogram`}
    >
      <span className="relative z-10">{initials.length > 1 ? initials : name.slice(0, 2)}</span>
      <span className="absolute -right-2 -top-2 h-5 w-5 rounded-full bg-[#B6FF5C]/50 blur-[6px]" />
    </div>
  );
}
